/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Two-factor-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseJanusManagementListAllSecondFactorsResponse,
  getCoinbaseJanusManagementListAllSecondFactorsResponseErrors,
} from '../../types/coinbase/janus/management/CoinbaseJanusManagementListAllSecondFactorsResponse';

export type ListAllSecondFactorsResult = CoinbaseJanusManagementListAllSecondFactorsResponse;

const validateListAllSecondFactorsResult = (value: unknown) => {
  const errors = getCoinbaseJanusManagementListAllSecondFactorsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ListAllSecondFactorsResult data does not match contract.`,
      errors,
    );
  }
};

export const getListAllSecondFactorsUrl = ({
  additionalParams,
  baseUrl,
}: {
  additionalParams?: Record<string, unknown>;
  baseUrl?: string;
} = {}) => {
  const searchParams = new URLSearchParams();
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/api/two-factor/v2/management${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ListAllSecondFactors
 * @Url /api/two-factor/v2/management
 * @Auth Required
 */

export function useGetListAllSecondFactors(
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ListAllSecondFactorsResult | undefined;

export function useGetListAllSecondFactors(options?: FetchOptions): ListAllSecondFactorsResult;

export function useGetListAllSecondFactors(
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getListAllSecondFactorsUrl(options);
  const data = useFetch<ListAllSecondFactorsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateListAllSecondFactorsResult(data);
  }

  return data;
}

/**
 * Access ListAllSecondFactors fetch callback
 */
export const useGetListAllSecondFactorsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (additionalHeaders?: Record<string, string>) => {
      const url = getListAllSecondFactorsUrl();
      const resource = getResource<ListAllSecondFactorsResult>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateListAllSecondFactorsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ListAllSecondFactors without throwing to suspense
 * @Url /api/two-factor/v2/management
 * @Auth Required
 */
export const useRefreshListAllSecondFactors = (
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getListAllSecondFactorsUrl();

  const { fetch } = useFetchableResource<ListAllSecondFactorsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ListAllSecondFactors from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /api/two-factor/v2/management
 */
export const useClearListAllSecondFactors = () => {
  const url = getListAllSecondFactorsUrl();

  const { clear } = useFetchableResource<ListAllSecondFactorsResult>(url);

  return clear;
};

export const useWithOptimisticListAllSecondFactorsUpdates = () => {
  const url = getListAllSecondFactorsUrl();

  const { optimisticUpdate } = useFetchableResource<ListAllSecondFactorsResult>(url);

  return optimisticUpdate;
};
